var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 43,
    viewBox: "0 0 31 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5155 1.18287L7.802 0.451868C9.94613 -0.232382 12.2369 0.874743 13.1549 3.03799L14.9824 7.34749C15.7771 9.22387 15.3351 11.4317 13.8901 12.8045L9.86325 16.6252C10.1119 18.9117 10.8811 21.1621 12.1689 23.3764C13.3917 25.5187 15.032 27.3938 16.9926 28.8907L21.8291 27.2757C23.6609 26.6659 25.6584 27.3692 26.7804 29.0204L29.4005 32.8666C30.7074 34.7876 30.4715 37.4354 28.8501 39.0631L27.114 40.8077C25.3843 42.5439 22.9129 43.175 20.6285 42.461C15.231 40.778 10.2734 35.7821 5.74713 27.4734C1.2145 19.1519 -0.385621 12.0884 0.948879 6.29137C1.50988 3.85187 3.246 1.90749 5.5155 1.18287Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.83337d77eaa722dd90e5ebdd983050da.svg";
export { ForwardRef as ReactComponent };